export default __webpack_public_path__ + "static/media/flexibleScaleLogo.b1e3e226.svg";